<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CustomerTaskForm from "./forms/customer-task-form.vue";
import CustomerTaskShow from "./show/show.vue";
import CustomTable from "../../../components/tables/custom-table.vue";
import AddButton from "../../../components/buttons/add-button.vue";
import api from "../../../helpers/apirest/api";

/**
 * Customers Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    AddButton,
    CustomerTaskForm,
    CustomerTaskShow,
    CustomTable
  },
  data() {
    return {
      formModalId:'customer-task-form-modal',
      showModalId:'customer-task-show-modal',
      pageHeader:{
        title: "Customer Tasks",
        breadcrumbs: [
          {
            text: "Customer Tasks",
            href: "/customer-tasks",
            active: true
          }
        ],
      },
      table:{
        url:'/customer-tasks',
        params: {
          'only_sync_task': 1,
        },
        fields:[
          { key: "id", label: "Cod", sortable: true },
          { key: "customer.fullname", label: "Customer", sortable: false },
          { key: "description", label: "Description", sortable: true },
          { key: "source_driver.fullname", label: "Source", sortable: false },
          { key: "target_driver.fullname", label: "Target", sortable: false },
          { key: "last_sync", label: "Last Successful Sync", sortable: true },
        ]
      },
      formSelectedItemId:null,   
      showSelectedItemId:null,
      clone:false
    };
  },
  methods: {
    showEditModal(item, clone = false) {
      this.formSelectedItemId = item?.id || null;
      this.clone = clone;
      this.$bvModal.show(this.formModalId);
    },
    showViewModal(item) {
      this.showSelectedItemId = item?.id || null;
      this.$bvModal.show(this.showModalId);
    },
    onSuccess(){
      this.$refs.customerTable.refresh();
    },
    async runTask(customerTask){
      try {

        /*const result = */await Vue.swal({
          title: "Run task now?",
          icon: "info",
          html:  "Are you sure you want to run this task right now?",
          showCloseButton: false,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return api.save({
                url: `customer-tasks/${customerTask?.id}/run-task`,
                successMsg: 'The synchronization task has been created successfully'
            }).then(()=>{});
          },
        });
        
      }
      catch (error) {
          console.log(error);
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="pageHeader?.title" :items="pageHeader?.breadcrumbs" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <CustomerTaskForm :modal-id="formModalId" :id="formSelectedItemId" @onSuccess="onSuccess" :clone="clone"></CustomerTaskForm>
            <CustomerTaskShow :modal-id="showModalId" :id="showSelectedItemId"></CustomerTaskShow>
            <div class="text-right">
              <AddButton @click="showEditModal"></AddButton>
            </div>
            <CustomTable :url="table.url" :fields="table.fields" :params="table.params" @edit="showEditModal" ref="customerTable" :show-view="true" @show="showViewModal" :show-modal-id="showModalId">
              <template v-slot:before-custom-actions="slotProps">
                <a
                    href="javascript:void(0);"
                    class="mr-3 text-primary"
                    v-b-tooltip.hover
                    title="Run task now"
                    @click="runTask(slotProps.row?.item)"
                >
                    <i class="ri-refresh-line font-size-18"></i>
                </a>
                <a
                    href="javascript:void(0);"
                    class="mr-3 text-primary"
                    v-b-tooltip.hover
                    title="Clone task"
                    @click="showEditModal(slotProps.row?.item, true)"
                >
                    <i class="ri-file-copy-line font-size-18"></i>
                </a>
              </template>
            </CustomTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>